import React, { memo } from 'react'
import { FlattenSimpleInterpolation } from 'styled-components'

// Hooks
import useWidth from '../../hooks/useWidth'
import useScroll from '../../hooks/useScroll'

// Assets
import Logo from '../Logo'

// Components
import Menu from '../Menu'

// Style
import { Header, LogoLink } from './style'
const WIDTH_LG = 992
interface IHeader {
  customHeaderStyle?: FlattenSimpleInterpolation;
  typeLanguage?: string;
  setTypeLanguage: Function;
 }

const HeaderComponent: React.FC<IHeader> = ({ customHeaderStyle, typeLanguage, setTypeLanguage }: IHeader) => {
  const scrollPositionY: number = useScroll(100)
  const fixedHeader = scrollPositionY > 70
  const windowWidth: number = useWidth(200)
  const isDesktop = windowWidth >= WIDTH_LG

  return (
    <>
      <Header
        className={`${fixedHeader ? 'drop-menu' : 'landscape'}`}
        customHeaderStyle={customHeaderStyle}
      >
        <div className='container'>
          <div className='row mx-0 align-items-center'>
            <LogoLink className='logo-link' to='/' title='Inter Asset'>
              <Logo width={isDesktop ? 225 : 170} height={isDesktop ? 32 : 28} className='inter-logo' />
              <h1 className='sr-only'>Banco Inter</h1>
            </LogoLink>
            <div className='px-md-0 flex-grow-1'>
              <Menu windowWidth={windowWidth} typeLanguage={typeLanguage} setTypeLanguage={setTypeLanguage}/>
            </div>
          </div>
        </div>
      </Header>
    </>
  )
}

export default memo(HeaderComponent)
